import React from "react";

function InfoCard({ title, subtitle, children, className = "" }) {
  const classes = ["ui-info-card", className].filter(Boolean).join(" ");

  return (
    <section className={classes}>
      {(title || subtitle) && (
        <header className="ui-info-card__header">
          {title && <h3 className="ui-info-card__title">{title}</h3>}
          {subtitle && <p className="ui-info-card__subtitle">{subtitle}</p>}
        </header>
      )}
      <div className="ui-info-card__body">{children}</div>
    </section>
  );
}

export default InfoCard;
